/** @prettier */
import { connect } from 'react-redux';

import {
  setCancelAllWarning,
  setSubmitAllWarning,
} from '@xanadu/ui-shared/modules/betslip/actions';
import { removeSelectionFromMultipleByCids } from '@xanadu/ui-shared/modules/multiples/actions';
import {
  cancelOpenOffersByIds,
  setAggregationRule,
} from '@xanadu/ui-shared/modules/openOffers/actions';
import { removeOffersByCids } from '@xanadu/ui-shared/modules/unsubmittedOffers/actions';
import { setShowBetConfirmation } from '@xanadu/ui-shared/modules/user/actions';

import { triggerUpdateRightSidebar } from '../../../modules/rightSidebar/actions';

import NewButtons from '../../../components/betslip/Buttons/NewButtons';

const mapDispatchToProps = {
  setShowBetConfirmation,
  onCancelOffers: cancelOpenOffersByIds,
  setCancelAllWarning,
  updateRightSidebar: triggerUpdateRightSidebar,
  onRemoveOffers: removeOffersByCids,
  setAggregationRule,
  onRemoveMultipleSelections: removeSelectionFromMultipleByCids,
  setSubmitAllWarning,
};

const mapStateToProps = (state) => ({
  showBetConfirmation: state.getIn(['user', 'showBetConfirmation']),
  config: state.get('betslip'),
  multiplesAvailable: state.getIn(['multiples', 'available']),
  activeFilters: state.getIn(['openOffers', 'activeFilters']),
  aggregationRuleStored: state.getIn(['openOffers', 'aggregationRule']),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewButtons);
